exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-row {\n  margin-bottom: 20px;\n&:last-child {\n    margin-bottom: 0;\n}\n}\n.cer-box .el-input__inner{\n    border:0;\n    box-shadow: none;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-63f728e0","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/view/base/setting/certificate/index.vue
// module id = 1542
// module chunks = 0